import { Trans, useTranslation } from 'react-i18next';
import BlueApptCss from '../styles/BlueMyTurnContent.module.css';
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import {
  withAITracking,
  useAppInsightsContext,
} from '@microsoft/applicationinsights-react-js';
import { reactPlugin } from '../utils/ApplicationInsightsService';

export function BlueMyTurnContent({htmlDir}) {

  const { _i18n } = useTranslation();

  const { _height, width } = useWindowDimensions();

  const appInsights = useAppInsightsContext();

  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }

  function useWindowDimensions() {
    const [windowDimensions, setWindowDimensions] = useState(
      getWindowDimensions(),
    );

    useEffect(() => {
      function handleResize() {
        setWindowDimensions(getWindowDimensions());
      }

      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }, []);

    return windowDimensions;
  }

  function visitMyTurnButton() {
    appInsights.trackEvent({ name: 'Visit My Turn Button Pressed' });
  }

  return (
    <div className={`${BlueApptCss.root}`}>
      {htmlDir === 'rtl' ? (
      <div className={BlueApptCss.myTurnImageContainerRtl}>
        {width > 950 ? (<img className={BlueApptCss.myTurnImage} src='/imgs/nathan.png'></img>) : (<div className={BlueApptCss.bkgImage}  style={{ backgroundImage: "url('/imgs/nathan.png')" }}></div>)}
      </div>) 
      : 
      (<div className={BlueApptCss.myTurnImageContainer}>
        {width > 950 ? (<img className={BlueApptCss.myTurnImage} src='/imgs/nathan.png'></img>) : (<div className={BlueApptCss.bkgImage}  style={{ backgroundImage: "url('/imgs/nathan.png')" }}></div>)}
        
      </div>)}
      <div className={BlueApptCss.blueApptContainer}>
        <div className={BlueApptCss.title}>
          <Trans i18nKey="landingPage.scheduleAppointment">
            Want to make a vaccine appointment?
          </Trans>
        </div>
        <div className={BlueApptCss.checkOutMyTurn}>
          <Trans i18nKey='landingPage.checkOutMyTurn'>
            Check out My Turn.
          </Trans>
        </div>
        <div className={BlueApptCss.blueMyTurnContent}>
          <Trans i18nKey='landingPage.blueMyTurnContent'>
            My Turn makes it easier to stay safe and protect your health year-round. Learn about the vaccinations we support, make an appointment, find a walk-in clinic, and more. 
          </Trans>
        </div>
        <div className={BlueApptCss.buttonContainer}>
          <br/>
            <Link to={{pathname: "https://myturn.ca.gov/"}} target="_blank" style={{ margin: '0' }} tabIndex={-1} >
              <button type="button" className={BlueApptCss.buttonStyle} onClick={visitMyTurnButton}>
                <Trans i18nKey="landingPage.visitMyTurn">Visit My Turn</Trans>
              </button>
            </Link>
        </div>
        {/* <div>
              <a className={BlueApptCss.bottomLink} href='https://uat.myturn.ca.gov/manage'>Visit My Turn</a><span className={BlueApptCss.arrowRight} style={{backgroundImage: "url('/landing-static/internal-arrow-white.svg')"}} />
          </div> */}
      </div>
    </div>
  );
}

export default BlueMyTurnContent;
